import { useQuery } from '@tanstack/react-query';

import { TutorAvailabilitiesService } from '../../services/TutorAvailabilitiesService';
import { GET_AVAILABLE_TIME_SLOTS_OF_TUTOR_QKEY } from '../../util/constants/queryKeys';

interface GetAvailableTimeSlotsOfTutorParams {
  tutorId: string;
  rescheduleFrom: string;
  rescheduleTo: string;
  studentTimeZone: string;
  packageId: string;
}

export const useGetAvailableTimeSlotsOfTutor = (
  params: GetAvailableTimeSlotsOfTutorParams,
  onSettled: (data: any) => void
) => {
  const { rescheduleTo, tutorId } = params;

  return useQuery({
    queryKey: [GET_AVAILABLE_TIME_SLOTS_OF_TUTOR_QKEY, rescheduleTo, tutorId],
    queryFn: () => TutorAvailabilitiesService.getAvailableTimeSlotsOfTutor(params),
    staleTime: 300000,
    enabled: !!rescheduleTo,
    onSettled(data) {
      onSettled(data);
    },
  });
};
